<template>
  <div class="update-user-pass">
     <TopBackNav class="top-back-nav" Navtitle="修改手机号" @backClick="backClick"></TopBackNav>

     <div class="updatePhone-tip">当前已绑定手机号：<span>{{showPhone}}</span>,更换后将使用新手机号</div>
    <div class="update-item-wrap">
       <div class="update-item-item">
        <span class="item-key">手机号码:</span>
        <input class="item-input" v-model="mobile" />
       </div>
       <div class="update-item-item">
        <span class="item-key">&nbsp;&nbsp;&nbsp;验证码:</span>
        <input class="item-input" v-model="phoneCode" />
        <button class="code-phone" @click="getAuthCode">{{authCodeBtnText}}</button>
       </div>
    </div>
    <el-button type="primary" class="save-btn" @click="saveClick">提交</el-button>
  </div>
</template>

<script>
import TopBackNav from './TopBackNav'
import cache from '@/common/cache.js'
export default {
  name: 'UpdateUserPhone',
  components: {
    TopBackNav
  },
  data () {
    return {
      authCodeBtnText: '获取验证码',
      mobile: '',
      phoneCode: '',
      countDownClock: 0,
      phone: ''
    }
  },
  mounted () {
    this.phone = cache.getPhone()
  },
  computed: {
    showPhone: function () {
      if (!this.phone) return ''
      return this.phone.substr(0, 3) + '****' + this.phone.substr(7);
    }
  },
  methods: {
    saveClick: function () {
      let params = {
        area_code: '86',
        mobile: this.mobile,
        auth_code: this.phoneCode
      }
      this.$api.liveServer.updatePhone(params).then(res => {
        if (res.code === 0) {
          this.$message.success('更改成功')
        } else {
          this.$message.error('获取验证码失败:' + res.msg)
        }
      })
    },
    backClick: function () {
      this.$emit('backClick')
    },
    getAuthCode () {
      if (this.countDownClock) {
        return
      }
      if (!this.mobile) {
        return this.$message.warning('请输入手机号')
      }
      var params = {area_code: '86', mobile: this.mobile}
      this.$api.liveServer.getPhoneCode(params).then(res => {
        if (res.code === 0) {
          this.countDown(60)
        } else {
          this.$message.error('获取验证码失败:' + res.msg)
        }
      })
    },
    countDown (wait) {
      if (!wait) {
        clearTimeout(this.countDownClock)
        this.countDownClock = null
        this.authCodeBtnText = '获取验证码'
      } else {
        this.authCodeBtnText = '获取验证码(' + wait + 's)'
        wait--
        this.countDownClock = setTimeout(() => {
          this.countDown(wait)
        }, 1000)
      }
    }
  }
}
</script>

<style>

  .top-back-nav{
    margin: 10;
  }
  .update-user-pass{
  }

  .update-item-item{
    margin-bottom: 20px;
    height: 30px;
    margin-top: 20px;
    margin-left: 30px;

    color: #4A4A4A;
    font-size: 15px;
  }

  .item-input{
    border: 1px solid #cccccc;
    border-radius: 4px;
    padding: 5px;
    margin-left: 15px;
  }

  .save-btn{
    margin-left: 120px;
    margin-top: 20px;
  }

  .updatePhone-tip{
    margin-left: 30px;
    margin-top: 20px;
    color: #C1C1C1;
  }

  .updatePhone-tip span{
    color: #2A2A2A;
  }

  .code-phone {
    width: 100px;
    height: 30px;
    background-color: #f1f1f1;
    border: none;
    border-radius: 10px;
    color: #999999;
    font-size: 12px;
    font-family: 'PingFangSC-Regular';
    letter-spacing: 0;
    outline: none;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/userinfo/UpdateUserPhone.vue